import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface TooltipConfig {
  title?: string;
  body: string;
  placement?: 'top' | 'top-end';
  targetElement: HTMLElement;
  span?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private addSubject = new Subject<TooltipConfig>();
  private removeSubject = new Subject<HTMLElement>();

  public added$ = this.addSubject.asObservable();
  public removed$ = this.removeSubject.asObservable();

  public add(config: TooltipConfig) {
    this.addSubject.next(config);
  }

  public remove(element: HTMLElement) {
    this.removeSubject.next(element);
  }
}
